import React, { ReactNode } from 'react'
import classNames from 'classnames'

interface SchemaBuilderNoticeCardProps {
    left: ReactNode
    right?: ReactNode
    className?: string
}

const SchemaBuilderNoticeCard: React.FC<SchemaBuilderNoticeCardProps> = ({
    left,
    right,
    className
}) => {

    return (
        <div

            className={classNames(className, 'd-flex justify-content-between align-items-center border rounded p-1 px-2 fs-5')}>
            {left}
            {right}
        </div>
    )
}

export { SchemaBuilderNoticeCard }
